import request from '../request.js'

// 获取菜单信息
const selectAll = function (data) {
    return request({
        url: 'sysBtn/selectAll',
        method: 'post',
        data
    })
}

const getBtnsByMenuId = function (data) {
    return request({
        url: 'sysBtn/getBtnsByMenuId',
        method: 'post',
        data
    })
}

const getBtnsByRoleIdMenuId = function (data) {
    return request({
        url: 'sysBtn/getBtnsByRoleIdMenuId',
        method: 'post',
        data
    })
}

const saveOrUpdate = function (data) {
    return request({
        url: 'sysBtn/saveOrUpdate',
        method: 'post',
        data
    })
}

const getInfoById = function (data) {
    return request({
        url: 'sysBtn/getInfoById',
        method: 'post',
        data
    })
}

const deleteById = function (data) {
    return request({
        url: 'sysBtn/deleteById',
        method: 'post',
        data
    })
}

export {
    selectAll,
    getBtnsByMenuId,        //菜单-按钮
    getBtnsByRoleIdMenuId,  //角色-菜单-按钮
    saveOrUpdate,
    getInfoById,
    deleteById,
}
